import { render, staticRenderFns } from "./index.vue?vue&type=template&id=547d3a7d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=547d3a7d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d3a7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547d3a7d')) {
      api.createRecord('547d3a7d', component.options)
    } else {
      api.reload('547d3a7d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=547d3a7d&scoped=true", function () {
      api.rerender('547d3a7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kx/config/index.vue"
export default component.exports